exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cell[data-v-76350c80]{font-size:12px;text-align:center;padding:0}.el-table td[data-v-76350c80],.el-table th[data-v-76350c80]{padding:4px 0}.table_box[data-v-76350c80]{margin-top:12px}.el-table .cell[data-v-76350c80],.el-table th div[data-v-76350c80]{padding-left:0;padding-right:0}.img_box_mini[data-v-76350c80]{width:50px;height:55px}.input-item-short[data-v-76350c80]{width:200px;height:44px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76350c80","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NewSkuSelection/index.vue
// module id = 281
// module chunks = 0